var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-STM"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STM",
    clipPath: "url(#clip-STM)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    transform: "translate(8.139 119.092)",
    fill: "#978e8e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,157.047H498.906L392.768,0H105.213Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 391.190673828125 0.4650930762290955 L 494.7027587890625 155.6553955078125 L 4.195255279541016 155.6553955078125 L 106.7932586669922 0.4650930762290955 L 391.190673828125 0.4650930762290955 M 392.7681274414062 -9.601186320651323e-06 L 105.2130813598633 -9.601186320651323e-06 L 3.857476986013353e-05 157.0471649169922 L 498.9061584472656 157.0471649169922 L 392.7681274414062 -9.601186320651323e-06 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    transform: "translate(3.231 229.954)",
    fill: "#978e8e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.67,0,487.094,1.449,502.129,46.16,0,48.229Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 498.5272216796875 43.79621124267578 L 485.1263732910156 3.629241228103638 L 9.475881576538086 2.360157012939453 L 3.623071908950806 45.64759826660156 L 498.5272216796875 43.79621124267578 M 502.1294860839844 46.15992736816406 L 8.497996896039695e-05 48.22907638549805 L 6.670078754425049 -1.742102904245257e-05 L 487.09375 1.449164032936096 L 502.1294860839844 46.15992736816406 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SRM-1",
    transform: "translate(143.5 221.5)",
    fill: "#f9f8f8",
    stroke: "#f9f4f4",
    strokeWidth: 1,
    fontSize: 38,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 41
  }, "SRM-1")), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 402,
    transform: "translate(55.5 268.5)",
    fill: "none",
    stroke: "#d2c9c9",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nut-and-bolt-tools-couple-svgrepo-com",
    transform: "translate(1.116 237.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(14.817 24.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M274.68,177.5a3.162,3.162,0,1,0,2.985,3.157A3.078,3.078,0,0,0,274.68,177.5Zm0,5.512a2.359,2.359,0,1,1,2.227-2.355A2.294,2.294,0,0,1,274.68,183.011Z",
    transform: "translate(-269.515 -175.748)",
    fill: "#aa5811",
    stroke: "#aa5811",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M221.685,143.438l-2.642,4.879,2.642,4.879h5.283l2.642-4.879-2.642-4.879Zm2.658,8.508a3.738,3.738,0,1,1,3.555-3.733A3.652,3.652,0,0,1,224.343,151.946Z",
    transform: "translate(-219.043 -143.438)",
    fill: "#aa5811",
    stroke: "#aa5811",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "nut-and-bolt-tools-couple-svgrepo-com-2",
    "data-name": "nut-and-bolt-tools-couple-svgrepo-com",
    transform: "translate(1.116 212.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185-2",
    "data-name": "Group 185",
    transform: "translate(14.817 24.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_326-2",
    "data-name": "Path 326",
    d: "M274.68,177.5a3.162,3.162,0,1,0,2.985,3.157A3.078,3.078,0,0,0,274.68,177.5Zm0,5.512a2.359,2.359,0,1,1,2.227-2.355A2.294,2.294,0,0,1,274.68,183.011Z",
    transform: "translate(-269.515 -175.748)",
    fill: "#aa5811",
    stroke: "#aa5811",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327-2",
    "data-name": "Path 327",
    d: "M221.685,143.438l-2.642,4.879,2.642,4.879h5.283l2.642-4.879-2.642-4.879Zm2.658,8.508a3.738,3.738,0,1,1,3.555-3.733A3.652,3.652,0,0,1,224.343,151.946Z",
    transform: "translate(-219.043 -143.438)",
    fill: "#aa5811",
    stroke: "#aa5811",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(460)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nut-and-bolt-tools-couple-svgrepo-com-3",
    "data-name": "nut-and-bolt-tools-couple-svgrepo-com",
    transform: "translate(4.116 237.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185-3",
    "data-name": "Group 185",
    transform: "translate(14.817 24.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_326-3",
    "data-name": "Path 326",
    d: "M274.68,177.5a3.162,3.162,0,1,0,2.985,3.157A3.078,3.078,0,0,0,274.68,177.5Zm0,5.512a2.359,2.359,0,1,1,2.227-2.355A2.294,2.294,0,0,1,274.68,183.011Z",
    transform: "translate(-269.515 -175.748)",
    fill: "#aa5811",
    stroke: "#aa5811",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327-3",
    "data-name": "Path 327",
    d: "M221.685,143.438l-2.642,4.879,2.642,4.879h5.283l2.642-4.879-2.642-4.879Zm2.658,8.508a3.738,3.738,0,1,1,3.555-3.733A3.652,3.652,0,0,1,224.343,151.946Z",
    transform: "translate(-219.043 -143.438)",
    fill: "#aa5811",
    stroke: "#aa5811",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "nut-and-bolt-tools-couple-svgrepo-com-4",
    "data-name": "nut-and-bolt-tools-couple-svgrepo-com",
    transform: "translate(1.116 212.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185-4",
    "data-name": "Group 185",
    transform: "translate(14.817 24.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_326-4",
    "data-name": "Path 326",
    d: "M274.68,177.5a3.162,3.162,0,1,0,2.985,3.157A3.078,3.078,0,0,0,274.68,177.5Zm0,5.512a2.359,2.359,0,1,1,2.227-2.355A2.294,2.294,0,0,1,274.68,183.011Z",
    transform: "translate(-269.515 -175.748)",
    fill: "#aa5811",
    stroke: "#aa5811",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327-4",
    "data-name": "Path 327",
    d: "M221.685,143.438l-2.642,4.879,2.642,4.879h5.283l2.642-4.879-2.642-4.879Zm2.658,8.508a3.738,3.738,0,1,1,3.555-3.733A3.652,3.652,0,0,1,224.343,151.946Z",
    transform: "translate(-219.043 -143.438)",
    fill: "#aa5811",
    stroke: "#aa5811",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 8,
    y2: 42,
    transform: "translate(464.5 232.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "boy-scouts-eagle-scout-logo-svgrepo-com",
    transform: "translate(414.656 223.651)",
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 24.922,
    cy: 26.244,
    rx: 24.922,
    ry: 26.244,
    transform: "translate(0 0)",
    fill: "#f3eeee"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 23.062,
    cy: 23.764,
    rx: 23.062,
    ry: 23.764,
    transform: "translate(1.86 2.48)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 18.103,
    cy: 17.978,
    rx: 18.103,
    ry: 17.978,
    transform: "translate(6.82 8.265)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M24.727,102.01l4.96-4.813a1.356,1.356,0,0,1,.911-.479.723.723,0,0,1,.69.712,1.362,1.362,0,0,1-.506.9l-4.96,4.812c-.74.717-1.193.471-1.4.26h0c-.2-.211-.437-.672.3-1.389Z",
    transform: "translate(-13.857 -60.951)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M57.911,107.785c-.176-1.014.283-1.25.572-1.3a.684.684,0,0,1,.522.109,1.353,1.353,0,0,1,.455.923l1.182,6.81a1.357,1.357,0,0,1-.117,1.023.685.685,0,0,1-.456.278.676.676,0,0,1-.521-.109,1.349,1.349,0,0,1-.455-.923l-1.182-6.81Z",
    transform: "translate(-31.756 -72.598)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M72.983,100.2l.353-.29,3.929,4.161-.958.788Z",
    transform: "translate(-40.621 -61.985)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M84.918,82.784l.074-.2c.429-1.171,1.158-1.006,2.141-.647.68.249,1.108.468,1.285.85a1.3,1.3,0,0,1-.051,1.033l-.074.2-3.375-1.235Z",
    transform: "translate(-46.945 -49.635)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M88.518,65.311v-.457l5.708-.4,0,1.24Z",
    transform: "translate(-53.042 -38.836)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M24.267,27.43l.314-.331L29,30.737l-.852.9Z",
    transform: "translate(-13.566 -16.757)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M71.84,28.962a1.34,1.34,0,0,1,.409-.944l4.423-5.312a1.353,1.353,0,0,1,.854-.573.681.681,0,0,1,.507.167c.226.188.506.621-.153,1.413l-4.423,5.312a1.357,1.357,0,0,1-.855.573.726.726,0,0,1-.762-.636Z",
    transform: "translate(-40.846 -14.011)",
    fill: "#595959"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStm);
export default __webpack_public_path__ + "static/media/STM.f4ad8637b40c3d388a186161d091ddde.svg";
export { ForwardRef as ReactComponent };